import { TemplateCuatro, TemplateDos, TemplateTres, TemplateUno } from "../Subcomponents/SectionRadioButton";

// Mapping of chart type IDs to their corresponding chart names
export const chartComponents = {
    1: 'line',
    2: 'bar',
    3: 'pie',
    4: 'donut',
    5: 'radar',
    6: 'polar',
};
// Template definitions with their associated section names
export const templates = {
    template1: ['section-a', 'section-b', 'section-c'],
    template2: ['section-d', 'section-e', 'section-f', 'section-g'],
    template3: ['section-h', 'section-i', 'section-j', 'section-k', 'section-l'],
    template4: ['section-m', 'section-n', 'section-o', 'section-p', 'section-q', 'section-r', 'section-s'],
};
// Used to identify which predefined template structure corresponds to a given ID
export const templateIdToTemplateName = {
    'b0dbd5a1-3bfa-4b23-871f-e159819414c1': 'template1',
    '0ba1b013-3111-4b0a-b5ba-1d74a1ff2a27': 'template2',
    '226d83d1-f82d-4be5-8347-f85aa7d483ea': 'template3',
    '6ebfbc2f-2532-4f44-b508-afaa9c514ec4': 'template4',
};
// Maps template IDs to their respective components
export const templateIdToComponent = {
    'b0dbd5a1-3bfa-4b23-871f-e159819414c1': <TemplateUno />,
    '0ba1b013-3111-4b0a-b5ba-1d74a1ff2a27': <TemplateDos />,
    '226d83d1-f82d-4be5-8347-f85aa7d483ea': <TemplateTres />,
    '6ebfbc2f-2532-4f44-b508-afaa9c514ec4': <TemplateCuatro />,
};

